import { TriangleAlertIcon } from "lucide-react";

import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "../ui/alert-dialog";
import { Button } from "../ui/button";
import { useOptionConfirmationStore } from "./optionConfirmationStore";

/** Asks before a model option with a warning (Ultrafast) takes effect. */
export function OptionConfirmationDialog() {
  const pending = useOptionConfirmationStore((state) => state.pending);
  const accept = useOptionConfirmationStore((state) => state.accept);
  const dismiss = useOptionConfirmationStore((state) => state.dismiss);
  const confirmation = pending?.confirmation;

  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) dismiss();
      }}
    >
      <AlertDialogPopup data-option-confirmation="true">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <TriangleAlertIcon aria-hidden="true" className="size-4 shrink-0 text-warning" />
            {confirmation?.title}
          </AlertDialogTitle>
          <AlertDialogDescription>{confirmation?.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogClose render={<Button variant="outline" />}>Cancel</AlertDialogClose>
          <Button variant="destructive" onClick={accept}>
            {confirmation?.confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
